import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { UserApiService } from './user-api.service';
import { IResponseBody } from 'src/app/interfaces/response-body';
import User from '../types/user';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { BehaviorSubject } from 'rxjs';

export class UserDataSource extends ApiDataSource {
  protected Data: BehaviorSubject<User[]> = new BehaviorSubject([]);

  constructor(
    protected Api: UserApiService,
    private readonly role: any,
    private readonly endpointUrl: any
  ) {
    super();
  }

  public save(User: User) {
    return this.Api.reset(User, this.role);
  }

  public async export() {
    const _pageEvent = {
      pageIndex: 0,
      pageSize: 10000,
      length: null,
    };
    let { data: users, pageEvent } = await this.Api.exportList(
      this.role,
      this.endpointUrl,
      _pageEvent
    );

    while (users.length < pageEvent.length) {
      pageEvent.pageIndex++;
      let { data } = await this.Api.exportList(
        this.role,
        this.endpointUrl,
        pageEvent
      );

      users = [...users, ...data];
    }

    return users;
  }

  public async updatePassword(userId) {
    return this.Api.updatePassword(userId, this.role);
  }

  protected loadData(PageEvent: PageEvent) {
    return this.Api.listWithPageEvent(
      this.role,
      this.endpointUrl,
      this.filter.value,
      PageEvent
    );
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }
}
